module.exports = __webpack_public_path__ + "assets/e00d1c94db5e0fdffe25166774c0db60.mp3";